<template>
    <div class="earn-item"
        v-if="earn.Type != 'redeem'">
        <div class="earn-img">
            <img class="img-fluid" :src="img">
        </div>
        <div class="earn-content">
            <div class="earn-info">
                <div class="date">{{earnDateFormat()}}</div>
                <div class="name">{{name}}</div>
            </div>
            <div class="used-point">{{`${point_txt} ${getPositivePoint()} ${lbl.history.point}`}}</div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import Moment from 'moment';
import Util from '@/helper/Utility.js';
export default {
    name: 'earn-item',
    props: {
        lbl: Object,
        earn: Object,
        earnConfig: Object
    },
    data: function () {
        return {
            name: '',
            type: '',
            img: '',
            point_txt: this.lbl.history.get_point
        };
    },
    created: function () {
        var type = this.earn.Type ? this.earn.Type.toLowerCase() : '';
        if (type == "preview") {
            if (this.earn.Detail) {
                if (this.earn.Detail.indexOf('|') >= 0) {
                    var arr = this.earn.Detail.split("|");
                    this.name = this.earnConfig[arr[0]].txt;
                    this.img = `${Vue.bzbsConfig.bzbsBlobUrl}${this.earnConfig[arr[0]].img}`;
                    this.type = arr[0];
                    this.point_txt = arr[1];
                } else {
                    this.name = this.earnConfig['other'].txt;
                    this.img = `${Vue.bzbsConfig.bzbsBlobUrl}${this.earnConfig['other'].img}`;
                    this.type = 'other';
                }
            } else {
                this.name = this.earnConfig['other'].txt;
                this.img = `${Vue.bzbsConfig.bzbsBlobUrl}${this.earnConfig['other'].img}`;
                this.type = 'other';
            }
        } else if (type == "trace" || type == "earn") {
            if (this.earn.Message) {
                let parsedJson = JSON.parse(this.earn.Message);
                let message = {...parsedJson[0]};

                switch (message.Id) {
                    case 'CFFWelcomePoint':
                    case 'CPFExistingWelcomePoint':
                        this.name = "Welcome Point";
                        this.img = `${Vue.bzbsConfig.bzbsBlobUrl}${this.earnConfig['other'].img}`;
                        this.point_txt = "ได้รับ";
                        break;
                    case 'CPFFeedInvitor':
                        this.name = "คะแนนเชิญเพื่อน";
                        this.img = `${Vue.bzbsConfig.bzbsBlobUrl}${this.earnConfig['other'].img}`;
                        this.point_txt = "ได้รับ";
                        break;
                    case 'FortuneWheel':
                        this.name = "รับแต้มจาก Surprise Bag";
                        this.img = `${Vue.bzbsConfig.bzbsBlobUrl}${this.earnConfig['luckydraw'].img}`;
                        this.point_txt = "ได้รับ";
                        break;
                    default:
                        this.name = this.earn.Detail;
                        this.img = `${Vue.bzbsConfig.bzbsBlobUrl}${this.earnConfig['other'].img}`;
                        this.point_txt = "ได้รับ";
                        break;
                }
            } 

            if (this.earn.Input) {
                let parsedJsonInput = JSON.parse(this.earn.Input);
                let channel = (parsedJsonInput.channel ? parsedJsonInput.channel.toLowerCase() : 
                              (parsedJsonInput.Channel ? parsedJsonInput.Channel.toLowerCase() : ''));

                if(channel == 'smartmore') {
                    switch (parsedJsonInput.activity) {
                        case 'IMPO':
                            this.name = "กิจกรรมการเพิ่มโค";
                            this.img = `${Vue.bzbsConfig.bzbsBlobUrl}${this.earnConfig['other'].img}`;
                            this.point_txt = "ได้รับ";
                            break;
                        case 'LogIN':
                            this.name = "กิจกรรมการเข้าสู่ระบบ Smartmore";
                            this.img = `${Vue.bzbsConfig.bzbsBlobUrl}${this.earnConfig['other'].img}`;
                            this.point_txt = "ได้รับ";
                            break;
                        case 'MATE':
                            this.name = "กิจกรรมการผสมพันธุ์โค";
                            this.img = `${Vue.bzbsConfig.bzbsBlobUrl}${this.earnConfig['other'].img}`;
                            this.point_txt = "ได้รับ";
                            break;
                        case 'REGISTER_FARM':
                            this.name = "กิจกรรมการเพิ่มฟาร์ม";
                            this.img = `${Vue.bzbsConfig.bzbsBlobUrl}${this.earnConfig['other'].img}`;
                            this.point_txt = "ได้รับ";
                            break;
                    }
                    
                } else if(channel == 'cpf') {
                    this.name = "กิจกรรม cpf online";
                    this.img = `${Vue.bzbsConfig.bzbsBlobUrl}${this.earnConfig['other'].img}`;
                    this.point_txt = "ได้รับ";
                }
            }
        } 
        else {
            this.name = this.earnConfig['other'].txt;
            this.img = `${Vue.bzbsConfig.bzbsBlobUrl}${this.earnConfig['other'].img}`;
            this.type = 'other';
        }
        
    },
    mounted: function () {
    },
    methods: {
        //util
        getPositivePoint: function () {
            var point = this.earn.Points;
            if (point < 0)
                point = point * -1

            return Util.formatNum(point);
        },
        formatNumber: function (point) {
            return Util.formatNum(point);
        },
        earnDateFormat: function () {
            var earnDate = this.earn.Timestamp;
            var message = this.lbl.detail.news_time;

            var result = Moment.unix(earnDate);
            var year = Moment.unix(earnDate).format('YYYY');
            if (this.localeCode === 1054)
                year = result.get('year') + 543;

            year = year.toString().substring(2, 4);
            var month = result.format('MM');
            var day = result.format('DD');

            var date = `${day}/${month}/${year}`;
            var time = result.format('HH:mm');
            //var monthString = this.lblDate.month_short[result.format('M') - 1];

            return Util.stringFormat(message, date, time);
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/common.scss";

.earn-item {
    display: flex;
    align-items: flex-start;
    padding: 16px 0;
    border-bottom: 1px solid $a-gray-C4C4C4;

    &:first-child {
        padding-top: 0;
    }

    .earn-img {
        @include baseCampaignImg(66.67%);
        width: 100px;
        height: auto;
        border-radius: 10px;
        box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.15);
    }
    .earn-content {
        width: calc(100% - 100px);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-left: 10px;

        .earn-info {

            .date {
                color: $a-gray-A0A0A0;
                font-family: $regular;
                font-size: 1.25rem;
                line-height: normal;
            }
            .name {
                @extend %ellipsis-2;
                color: $a-gray-333333;
                font-family: $regular;
                font-size: 1.5rem;
                line-height: normal;
            }
        }

        .used-point {
            color: $green-00987F;
            font-family: $semi_bold;
            font-size: 1.5rem;
            line-height: normal;
            margin-top: 10px;
        }
    }
}

</style>
